import { useState } from 'react'

import { AbTestVariantsSchema } from 'features/ab-tests/types/abTestVariantsSchema'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_AB_TEST_VARIANTS_SCHEMA } from './api/query'
import { Data, Variables } from './api/types'

import type { Props, UseGetAbTestVariantsSchema } from './types'

export const useGetAbTestVariantsSchema = ({ domainId }: Props): UseGetAbTestVariantsSchema => {
  const [schema, setSchema] = useState<AbTestVariantsSchema>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { abTestVariantsSchema } = data

      if (abTestVariantsSchema) {
        setSchema(fromDTO(abTestVariantsSchema))
      }
    },
    options: {
      enabled: Boolean(domainId),
    },
    query: GET_AB_TEST_VARIANTS_SCHEMA,
    variables: { domainId: domainId! },
  })

  return {
    loading,
    schema,
  }
}
